import axios from 'axios';
import { HOST_API } from '../config';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (cookies.get('admin_token')) {
      config.headers.Authorization = `${cookies.get('admin_token')}`;
    }
    return { ...config };
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
